import type { FetchPartnerQuery, PartnerCallLogStatsQuery } from '@/gql/graphql';
import { PartnerNewSubsidy } from '@/gql/graphql';

export type Partner = Extract<FetchPartnerQuery['partner'], {}>;
type PartnerRideAllowance = Extract<Partner['rideAllowance'], {}>;
export type PartnerRideAllowanceTier = Extract<PartnerRideAllowance['tiers'], {}>[number];
export type PartnerCallLogStat = Extract<PartnerCallLogStatsQuery['partnerCallLogStats'], {}>;

export enum PartnerCodeName {
  INNISFIL = 'innisfil',
  TOLLESON = 'tolleson',
  WASHINGTON = 'washington',
  STA = 'sta',
  STA20 = 'sta20',
  STA5 = 'sta5',
  STA100 = 'sta100',
  STAVET20 = 'stavet20',
  STAVET40 = 'stavet40',
  HAMV = 'hamv',
  WINDSOR = 'windsor',
  FRESNO = 'fresno',
  MASONIC = 'masonic',
  LEWIS = 'lewis',
  CHENANGO = 'chenango',
  CLINTON = 'clinton',
  OSWEGO = 'oswego',
  MONTGOMERY = 'montgomery',
  FULTON = 'fulton',
  ALLEGANY = 'allegany',
  LIVINGSTON = 'livingston',
  YATES = 'yates',
  ONEIDA = 'oneida',
  UMASS = 'umass',
  UMASSNICU = 'umassnicu',
  PUTNAM = 'putnam',
  CAYUGA = 'cayuga',
  WYOMING = 'wyoming',
  NEWTON = 'newton',
  NEWTONVL = 'newtonvl',
  NEWTONLO = 'newtonlo',
  NEWTONSTANDARD = 'newtonstandard',
  NEWTONTRIO = 'newtontrio',
  CHEMUNG = 'chemung',
  COLLABORATIVE = 'collaborative',
  JURORS = 'jurors',
  CVRC = 'cvrc',
  ACRC = 'acrc',
  ORIONISO = 'orioniso',
  ACEFMS = 'acefms',
  MONTCO = 'montco',
  VRNHBERLIN = 'vrnhberlin',
  VRNHCONCORD = 'vrnhconcord',
  VRNHKEENE = 'vrnhkeene',
  VRNHMANCHESTER = 'vrnhmanchester',
  VRNHNASHUA = 'vrnhnashua',
  VRNHPORTSMOUTH = 'vrnhportsmouth',
  VRNHSERVICES = 'vrnhservices',
  VRNHVIRTUAL = 'vrnhvirtual',
  NCEIPD_RALEIGH = 'nceipdraleigh',
  NCEIPD_CHARLOTTE = 'nceipdcharlotte',
  ADRS_ANDALUSIA = 'adrsandalusia',
  ADRS_ANNISTON = 'adrsanniston',
  ADRS_BIRMINGHAM_LAKESHORE = 'adrsbirminghamlakeshore',
  ADRS_COLUMBIANA = 'adrscolumbiana',
  ADRS_DECATUR = 'adrsdecatur',
  ADRS_DOTHAN = 'adrsdothan',
  ADRS_GADSDEN = 'adrsgadsden',
  ADRS_HOMEWOOD_BIRMINGHAM = 'adrshomewoodbirmingham',
  ADRS_HUNTSVILLE = 'adrshuntsville',
  ADRS_JACKSON = 'adrsjackson',
  ADRS_JASPER = 'adrsjasper',
  ADRS_MOBILE = 'adrsmobile',
  ADRS_MONTGOMERY = 'adrsmontgomery',
  ADRS_MUSCLE_SHOALS = 'adrsmuscleshoals',
  ADRS_OPELIKA = 'adrsopelika',
  ADRS_PRATTVILLE = 'adrsprattville',
  ADRS_SCOTTSBORO = 'adrsscottsboro',
  ADRS_SELMA = 'adrsselma',
  ADRS_TALLADEGA = 'adrstalladega',
  ADRS_TROY = 'adrstroy',
  ADRS_TUSCALOOSA = 'adrstuscaloosa',
  GVRA_MARIETTA = 'gvramarietta',
  GVRA_CANTON = 'gvracanton',
  GVRA_LAFAYETTE = 'gvralafayette',
  GVRA_ROME = 'gvrarome',
  GVRA_ELLIJAY = 'gvraellijay',
  GVRA_ATLANTA = 'gvraatlanta',
  GVRA_TUCKER = 'gvratucker',
  GVRA_COLLEGE_PARK = 'gvracollegepark',
  GVRA_JOHNS_CREEK = 'gvrajohnscreek',
  GVRA_CONYERS = 'gvraconyers',
  GVRA_GAINESVILLE = 'gvragainesville',
  GVRA_CLEVELAND = 'gvracleveland',
  GVRA_ATHENS = 'gvraathens',
  GVRA_CARROLLTON = 'gvracarrollton',
  GVRA_WARM_SPRINGS = 'gvrawarmsprings',
  GVRA_COLUMBUS = 'gvracolumbus',
  GVRA_MACON = 'gvramacon',
  GVRA_MILLEDGEVILLE = 'gvramilledgeville',
  GVRA_WARNER_ROBINS = 'gvrawarnerrobins',
  GVRA_AUGUSTA = 'gvraaugusta',
  GVRA_DUBLIN = 'gvradublin',
  GVRA_STATESBORO = 'gvrastatesboro',
  GVRA_SAVANNAH = 'gvrasavannah',
  GVRA_BRUNSWICK = 'gvrabrunswick',
  GVRA_WAYCROSS = 'gvrawaycross',
  GVRA_VALDOSTA = 'gvravaldosta',
  GVRA_TIFTON = 'gvratifton',
  GVRA_ALBANY = 'gvraalbany',
  GVRA_THOMASVILLE = 'gvrathomasville',
  DIAMOND_BAR = 'diamondBar',
  DEMO = 'demo',
}

export const NC_EIPD_PARTNERS: readonly PartnerCodeName[] = [PartnerCodeName.NCEIPD_RALEIGH, PartnerCodeName.NCEIPD_CHARLOTTE] as const;

export const NEWTON_PARTNERS = [
  PartnerCodeName.NEWTON,
  PartnerCodeName.NEWTONLO,
  PartnerCodeName.NEWTONSTANDARD,
  PartnerCodeName.NEWTONTRIO,
  PartnerCodeName.NEWTONVL,
];

export const SolanoCountyPartners = [
  PartnerCodeName.STA,
  PartnerCodeName.STA20,
  PartnerCodeName.STAVET20,
  PartnerCodeName.STAVET40,
  PartnerCodeName.STA100,
  PartnerCodeName.STA5,
  PartnerCodeName.COLLABORATIVE,
  PartnerCodeName.JURORS,
];

export const VRNH_PARTNERS = [
  PartnerCodeName.VRNHBERLIN,
  PartnerCodeName.VRNHCONCORD,
  PartnerCodeName.VRNHKEENE,
  PartnerCodeName.VRNHMANCHESTER,
  PartnerCodeName.VRNHNASHUA,
  PartnerCodeName.VRNHPORTSMOUTH,
  PartnerCodeName.VRNHSERVICES,
  PartnerCodeName.VRNHVIRTUAL,
];

export const ADRS_PARTNERS = [
  PartnerCodeName.ADRS_ANDALUSIA,
  PartnerCodeName.ADRS_ANNISTON,
  PartnerCodeName.ADRS_BIRMINGHAM_LAKESHORE,
  PartnerCodeName.ADRS_COLUMBIANA,
  PartnerCodeName.ADRS_DECATUR,
  PartnerCodeName.ADRS_DOTHAN,
  PartnerCodeName.ADRS_GADSDEN,
  PartnerCodeName.ADRS_HOMEWOOD_BIRMINGHAM,
  PartnerCodeName.ADRS_HUNTSVILLE,
  PartnerCodeName.ADRS_JACKSON,
  PartnerCodeName.ADRS_JASPER,
  PartnerCodeName.ADRS_MOBILE,
  PartnerCodeName.ADRS_MONTGOMERY,
  PartnerCodeName.ADRS_MUSCLE_SHOALS,
  PartnerCodeName.ADRS_OPELIKA,
  PartnerCodeName.ADRS_PRATTVILLE,
  PartnerCodeName.ADRS_SCOTTSBORO,
  PartnerCodeName.ADRS_SELMA,
  PartnerCodeName.ADRS_TALLADEGA,
  PartnerCodeName.ADRS_TROY,
  PartnerCodeName.ADRS_TUSCALOOSA,
];

export const GVRA_PARTNERS = [
  PartnerCodeName.GVRA_MARIETTA,
  PartnerCodeName.GVRA_CANTON,
  PartnerCodeName.GVRA_LAFAYETTE,
  PartnerCodeName.GVRA_ROME,
  PartnerCodeName.GVRA_ELLIJAY,
  PartnerCodeName.GVRA_ATLANTA,
  PartnerCodeName.GVRA_TUCKER,
  PartnerCodeName.GVRA_COLLEGE_PARK,
  PartnerCodeName.GVRA_JOHNS_CREEK,
  PartnerCodeName.GVRA_CONYERS,
  PartnerCodeName.GVRA_GAINESVILLE,
  PartnerCodeName.GVRA_CLEVELAND,
  PartnerCodeName.GVRA_ATHENS,
  PartnerCodeName.GVRA_CARROLLTON,
  PartnerCodeName.GVRA_WARM_SPRINGS,
  PartnerCodeName.GVRA_COLUMBUS,
  PartnerCodeName.GVRA_MACON,
  PartnerCodeName.GVRA_MILLEDGEVILLE,
  PartnerCodeName.GVRA_WARNER_ROBINS,
  PartnerCodeName.GVRA_AUGUSTA,
  PartnerCodeName.GVRA_DUBLIN,
  PartnerCodeName.GVRA_STATESBORO,
  PartnerCodeName.GVRA_SAVANNAH,
  PartnerCodeName.GVRA_BRUNSWICK,
  PartnerCodeName.GVRA_WAYCROSS,
  PartnerCodeName.GVRA_VALDOSTA,
  PartnerCodeName.GVRA_TIFTON,
  PartnerCodeName.GVRA_ALBANY,
  PartnerCodeName.GVRA_THOMASVILLE,
];

export enum PartnerRegistrationSteps {
  CreateUpdatePartnerInfo = 0,
  Communication = 1,
  EnrollmentCriteria = 2,
  SubsidyInfo = 3,
  ServiceTimes = 4,
  TaxiVendors = 5,
  Payment = 6,
}

export enum PartnerCustomerRegistrationSteps {
  CustomerInformation = 0,
  FamilyMember = 1,
  Payment = 2,
  Final = 3,
}

export interface PartnerRegistrationDataType {
  name: string;
  codeName: string;
  registrationLink: string;
  infoForOperator?: string;
  subsidyDescription?: string;
  address?: string;
  gogoNumber: string;
  extension?: number;
  isHideRegistrationLink: boolean;
  isSelfServeDashboard: boolean;
}

export interface PartnershipNotifyDataType {
  name: string;
  notifyText: string;
}

export { PartnerNewSubsidy };
